import { render, staticRenderFns } from "./FichaVentaEquipos.vue?vue&type=template&id=0aed21e8&scoped=true"
import script from "./FichaVentaEquipos.vue?vue&type=script&lang=js"
export * from "./FichaVentaEquipos.vue?vue&type=script&lang=js"
import style0 from "./FichaVentaEquipos.vue?vue&type=style&index=0&id=0aed21e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed21e8",
  null
  
)

export default component.exports